import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HomeService {
  constructor(private http: HttpClient) {}

  public async loadAsync(teamName: string) {
    return lastValueFrom(this.http.get(`${ConfigService.apiUrl}/home/${teamName}`));
  }

  public load(teamName: string) {
    return this.http.get(`${ConfigService.apiUrl}/home/${teamName}`);
  }
}
